import * as type from '../types/notification';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var sendNotification = actionCreator(type.SEND_NOTIFICATION);